export default "./fonts/survio-XU_Aa-fonts-icomoon.ttf";